import { MutableRefObject } from 'react'
import { useAuth } from 'hooks/UseAuth'
import { useSelector } from 'react-redux'
import { RootState } from 'types'
import { FormWithSubmit } from 'components/WorkspaceMembershipProfileForm/FormWithSubmit'
import { useObjectRef } from 'utils/useObjectRef'
import { FormRef } from 'components/Form/Form'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

import SettingsStyles from '../SettingsModal.module.scss'
import Styles from './DirectoryProfile.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Modal, useModals } from 'almanac-ui/Modal'
import { Heading } from 'blaze-ui/Heading/Heading'

const DirectoryProfile = () => {
  const auth = useAuth()
  const { closeModal } = useModals()
  const currentWorkspaceId = useSelector((state: RootState) => state.workspace.currentWorkspaceId)
  const formRef = useObjectRef<FormRef>()
  const submitButtonContainer = useObjectRef<HTMLDivElement>()
  const { isMobile } = useResponsiveDesign()
  return (
    <>
      {!isMobile && (
        <div className={Styles.formTitle}>
          <Heading level={3}>Profile</Heading>
        </div>
      )}
      <section className={Styles.formBody}>
        <FormWithSubmit
          ref={formRef}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          memberId={auth?.id!}
          workspaceId={currentWorkspaceId}
          submitButtonContainer={submitButtonContainer as MutableRefObject<HTMLDivElement>}
          onComplete={() => {
            showToastMessage('Profile details are successfully saved', 'success')
          }}
        />
      </section>
      <div className={Styles.footer}>
        <Modal.Footer>
          <Modal.FooterContent slot="left">
            {isMobile && (
              <Modal.FooterButton size="lg" variant="tertiary" onPress={closeModal}>
                Cancel
              </Modal.FooterButton>
            )}
          </Modal.FooterContent>
          <Modal.FooterContent slot="right">
            <div className={Styles.submitButton} ref={submitButtonContainer} />
          </Modal.FooterContent>
        </Modal.Footer>
      </div>
    </>
  )
}

export { DirectoryProfile }
